import { CORNER_LOGO_PATH, CORNER_LOGO_VIEWBOX_H, CORNER_LOGO_VIEWBOX_W } from "./cornerLogoPath";

type Props = {
    color?: string;
    width?: string | number;
    height?: string | number;
    viewBox?: string;
};

export default function QLogo({
    color = "#3D9CF5",
    width = 200,
    height = 187,
    viewBox = `0 0 ${CORNER_LOGO_VIEWBOX_W} ${CORNER_LOGO_VIEWBOX_H}`,
}: Props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill={color} d={CORNER_LOGO_PATH} />
        </svg>
    );
}
